enum Locale {
  POLISH = 'pl-PL',
  ENGLISH = 'en-GB',
  UKRAINIAN = 'uk-UA',
}

export default Locale;
